import { jsx as s } from "react/jsx-runtime";
import { createContext as v, useContext as y, useState as g, useEffect as h, useMemo as f, useCallback as P } from "react";
import { theme as R, ConfigProvider as M, App as T } from "antd";
import U from "antd/locale/en_US.js";
import F from "antd/locale/fr_FR.js";
const x = {
  token: {
    colorPrimary: "#1677ff",
    colorInfo: "#1677ff",
    borderRadius: 8,
    fontFamily: "Inter, sans-serif"
  }
}, w = {
  algorithm: R.darkAlgorithm,
  token: {
    ...x.token
  }
}, p = {
  en_US: U,
  fr_FR: F
}, A = v({
  locale: "en_US",
  setLocale: () => {
  }
}), E = "antd-locale", K = ({ children: d, initialLocale: o }) => {
  const [e, r] = g(o ?? "en_US");
  h(() => {
    if (o) return;
    let t = null;
    try {
      t = localStorage.getItem(E);
    } catch (l) {
      console.error("Error accessing localStorage:", l);
    }
    t && p[t] && r(t);
  }, [o]);
  const m = (t) => {
    r(t);
    try {
      localStorage.setItem(E, t);
    } catch (l) {
      console.error("Error writing localStorage:", l);
    }
  }, a = f(() => ({ locale: e, setLocale: m }), [e]);
  return /* @__PURE__ */ s(A.Provider, { value: a, children: /* @__PURE__ */ s(M, { locale: p[e], children: d }) });
}, j = () => y(A), I = v({
  mode: "light",
  toggleTheme: () => {
  }
}), L = "theme-mode", k = "theme-mode-manual", z = ({ children: d, initialTheme: o }) => {
  const [e, r] = g("light"), [m, a] = g(!1);
  h(() => {
    let n;
    try {
      if (o)
        r(o), a(!0);
      else {
        const S = localStorage.getItem(k) === "1";
        a(S);
        const _ = localStorage.getItem(L);
        if (S)
          r(_ === "dark" ? "dark" : "light");
        else {
          const c = window.matchMedia("(prefers-color-scheme: dark)"), i = () => r(c.matches ? "dark" : "light");
          i(), typeof c.addEventListener == "function" ? (c.addEventListener("change", i), n = () => c.removeEventListener("change", i)) : typeof c.addListener == "function" && (c.addListener(i), n = () => c.removeListener(i));
        }
      }
    } catch (u) {
      console.error("Error initializing theme mode:", u);
    }
    return n;
  }, [o]);
  const t = P(() => {
    a(!0), r((n) => n === "light" ? "dark" : "light");
  }, []);
  h(() => {
    try {
      localStorage.setItem(L, e), localStorage.setItem(k, m ? "1" : "0");
    } catch (n) {
      console.error("Error persisting theme mode:", n);
    }
  }, [e, m]);
  const l = f(() => e === "light" ? x : w, [e]), C = f(() => ({ mode: e, toggleTheme: t }), [e, t]);
  return /* @__PURE__ */ s(K, { children: /* @__PURE__ */ s(I.Provider, { value: C, children: /* @__PURE__ */ s(M, { theme: l, children: /* @__PURE__ */ s(T, { children: d }) }) }) });
}, N = () => y(I);
export {
  z as AppThemeProvider,
  K as LocaleProvider,
  w as dark,
  x as light,
  j as useLocale,
  N as useTheme
};
//# sourceMappingURL=index.js.map
